import * as React from 'react';

function IconFoldedDoc(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_11_19445)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.019 27.78V4.22c0-.42.34-.76.76-.76h14.803l6.4 6.4v17.92c0 .42-.34.76-.76.76H5.78a.76.76 0 01-.76-.76z"
          fill="#E5E9EE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.342 9.86h5.64l-6.4-6.4V9.1c0 .42.34.76.76.76z"
          fill="#C0C7D1"
        />
        <path
          d="M26.982 23.65H5.018v.759h21.964v-.76zM26.982 20.058H5.018v.76h21.964v-.76zM26.982 16.467H5.018v.76h21.964v-.76zM26.982 12.877H5.018v.759h21.964v-.76z"
          fill="#D0D5DA"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_11_19445">
          <path fill="#fff" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoIconFoldedDoc = React.memo(IconFoldedDoc);
export default MemoIconFoldedDoc;
